export default __webpack_public_path__ + "static/media/01Gwalior.d50ccb29.jpg";